<template>
  <div class="profile-avatar d-flex flex-column justify-content-center mb-3" v-if="value">
    <div class="position-relative rounded" style="min-width: 200px">
      <b-img :src="value.url" style="max-width: 200px" />
      <div v-if="!displayOnly && value.id" class="delete d-flex justify-content-center bg-danger" @click="remove">
        <i class="flaticon-cancel p-0" />
      </div>
    </div>
    <div v-if="!displayOnly && !value.id" class="buttons">
      <b-button variant="outline-primary" class="mt-2" @click="chooseFile"> Загрузить фото </b-button>
      <b-form-file :id="this.id" class="d-none" v-model="avatar" accept=".jpg, .png, .jpeg" @input="load" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.profile-avatar {
  width: 200px;
}
.delete {
  border-radius: 2px 0;
  position: absolute;
  top: 0px;
  width: 20px;
  height: 20px;
  color: white;
  cursor: pointer;
  * {
    cursor: pointer;
  }
}
</style>

<script>
import Api from "shared/service/api/api";
import { mapGetters } from "vuex";
import { LOAD_USER } from "shared/store/modules/auth.store";

export default {
  name: "AvatarEditor",
  props: {
    value: {},
    modelId: null,
    modelTypeId: null,
    modelPropertyName: null,
    displayOnly: null,
  },
  computed: {
    ...mapGetters(["currentUser"]),
  },
  data() {
    return {
      id: "AvatarEditor_" + Date.now(),
      avatar: null,
    };
  },
  methods: {
    chooseFile() {
      document.getElementById(this.id).click();
    },
    load() {
      !this.displayOnly &&
        this.avatar &&
        Api.multimedia.image
          .upload(this.avatar, {
            modelId: this.modelId,
            modelTypeId: this.modelTypeId,
            modelPropertyName: this.modelPropertyName,
            isInput: true,
          })
          .then((response) => {
            if (!response.success) {
              throw new Error(response.error);
            }

            this.$emit("input");
            this.$store.dispatch(LOAD_USER);
          })
          .catch((e) => {
            this.$alert.error("Не удалось загрузить изображение<br>" + e.message);
          });
    },
    remove() {
      Api.multimedia.image
        .delete(this.value.id, this.modelId, this.modelTypeId, this.modelPropertyName)
        .then((response) => {
          if (!response.success) {
            throw new Error(response.error);
          }

          this.$emit("input");
          this.$store.dispatch(LOAD_USER);
        })
        .catch((e) => {
          this.$alert.error("Ошибка удаления изображения<br>" + e.message);
        });
    },
  },
};
</script>
